import { useContext } from 'react';
import useSWR from 'swr';
import { UseSWRMutationResult } from '../../common/types/swrTypes';
import { buildQueryString, deleteToApi, postToApi, putToApi } from '../../common/utils/apiHelper';
import { ConfigContext } from '../configuration/ConfigContext';
import { usePropertyAssociationContext } from '../propertyAssociation/PropertyAssociationContext';
import { AddApartmentRequest } from './models/AddApartmentRequest';
import { GetApartmentsResponse } from './models/GetApartmentsResponse';
import { UpdateApartmentFeaturesRequest } from './models/UpdateApartmentFeaturesRequest';

type UseApartmentsResult = UseSWRMutationResult<GetApartmentsResponse, 'response'>;

export const useApartments = (): UseApartmentsResult => {
    const { apiBaseUrl } = useContext(ConfigContext);
    const { currentPropertyAssociationId, currentArea } = usePropertyAssociationContext();

    const url = currentPropertyAssociationId
        ? `${apiBaseUrl}/propertyassociations/${currentPropertyAssociationId}/apartments${buildQueryString({ areaId: currentArea?.propertyAssociationAreaId })}`
        : null;

    const { data, error, isLoading, mutate } = useSWR<GetApartmentsResponse>(url);

    return {
        response: data,
        isLoading,
        error,
        refetch: () => mutate(),
    };
};

export const addApartment = (apiBaseUrl: string, propertyAssociationId: string, request: AddApartmentRequest, onSuccess: () => void, onFail: () => void): void => {
    postToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/apartments`, request, onSuccess, onFail);
};

export const deleteApartment = (apiBaseUrl: string, propertyAssociationId: string, apartmentId: string, onSuccess: () => void, onFail: () => void): void => {
    deleteToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/apartments/${apartmentId}`, onSuccess, onFail);
};

export const updateApartment = (apiBaseUrl: string, propertyAssociationId: string, apartmentId: string, request: UpdateApartmentFeaturesRequest, onSuccess: () => void, onFail: () => void): void => {
    putToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/apartments/${apartmentId}`, request, onSuccess, onFail);
};
